module.exports = __webpack_public_path__ + "img/ImagineerTypesQuiz_Q2-lockup.0bdc25e4.png";